var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"mask",class:{ show: _vm.visible, hide: !_vm.visible },on:{"touchmove":function($event){$event.stopPropagation();$event.preventDefault();
arguments[0] = $event = _vm.$handleEvent($event);
(function () {}).apply(void 0, arguments)
}}},[_c('v-uni-view',{staticClass:"inner-area",class:{ show: _vm.visible2, hide: !_vm.visible2 }},[_c('v-uni-view',{staticClass:"content-wrapper"},[_vm._t("default")],2),_c('v-uni-view',{staticClass:"tripwise_outline icon-pop_close_outline a-w-90 a-h-90 a-fs-90 a-c-_f a-m-20-auto-0-auto",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.handleCloseMask).apply(void 0, arguments)
}}})],1)],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }